import * as React from "react"
import { AppTableSeeker } from "@components"

import {GROUPED_BY} from "../../@constants";
import {countryColumn, brandColumn, retailerWithCountryColumn, retailerWithoutCountryColumn, scoreColumn, companyColumn, sellerColumn} from "./columns";


export default function KpiTable({ data=[], aggregations=[], kpis=[], showOverallStyles=false, ...props }) {

    if (data.length === 0)
        return <></>

    return <AppTableSeeker
        data={data}
        columns={[
            ...(aggregations.includes(GROUPED_BY.COUNTRY) ? countryColumn() : []),
            ...(aggregations.includes(GROUPED_BY.RETAILER) && aggregations.includes(GROUPED_BY.COUNTRY) ? [retailerWithCountryColumn()] : []),
            ...(aggregations.includes(GROUPED_BY.RETAILER) && !aggregations.includes(GROUPED_BY.COUNTRY) ? retailerWithoutCountryColumn() : []),
            ...(aggregations.includes(GROUPED_BY.COMPANY) ? [companyColumn()] : []),
            ...(aggregations.includes(GROUPED_BY.BRAND) ? [brandColumn()] : []),
            ...(aggregations.includes(GROUPED_BY.SELLER) ? [sellerColumn()] : []),
            ...kpis.map(({ name, label, links, visibility=true }) => scoreColumn(name, label, showOverallStyles, aggregations, links, visibility))
        ]}
        options={{
            enhancedSetRowProps: () => ({ sx: {
				"&:has(.is-all)": {backgroundColor: "primary.lighter"}
			} })
        }}
        {...props}
    />
}